import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-button-box',
    templateUrl: './button-box.component.html',
    styleUrls: ['./button-box.component.css'],
    standalone: false
})
export class ButtonBoxComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }
}
